import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ContactToday = () => {
  const { t } = useTranslation();


  return (
    <section className="mt-32 bg-[#F67E20]">
      <div className="mx-auto px-5 max-w-[1290px] w-full p-24">
        <div className="flex flex-col lg:w-[50%]">
          <h2 className="text-[27.65px] leading-[33.18px] font-extrabold text-[#FFF8ED] mb-4 mt-10">
          {t("orange.title")}
          </h2>
          <p className="text-[#FFF8ED] mb-6 text-[16px] leading-[20.8px] font-normal">
          {t("orange.description")}
                    </p>
        </div>
        <Link
          to="/contactus"
          className="flex w-[120px] items-center justify-center gap-2 p-[10px_24px] rounded-[12px] bg-[#FFF8ED] text-[#F67E20] hover:bg-[#111111] hover:text-[#FEEED6] font-medium transition-all duration-300 ease-in-out"
        >
           {t("nav.contact")} <i className="fa-solid fa-paper-plane"></i>
        </Link>
      </div>


    </section>
  );
};

export default ContactToday;
